import getConfig from '../env';
import { isCCApp } from './api';

export const getProductRoadMapUpdates = () => [
  {
    activities: [],
    id: 'PRODUCT_ROADMAP',
    name: 'product-roadmap',
    url: getConfig('PRODUCT_ROADMAP'),
    target: '_self'
  },
  {
    activities: [],
    id: 'PRODUCT_UPDATES',
    name: 'product-updates',
    url: isCCApp()
      ? getConfig('CC_PRODUCT_UPDATES')
      : getConfig('PRODUCT_UPDATES'),
    target: '_blank'
  }
];

export const BudgetOverview = [
  {
    activities: [],
    id: 'BUDGET_OVERVIEW',
    name: 'budget-overview',
    url: '/ui/budget/budgetOverview',
    target: '_self'
  }
];

export const IntegrationSettings = [
  {
    activities: [],
    id: 'INTEGRATON_SETTINGS',
    name: 'integration-settings',
    url: '/',
    target: '_self'
  },
  {
    activities: [],
    id: 'WORKDAY_INTEGRATION',
    name: 'workday-integration',
    url: '/workday',
    target: '_self'
  },
  {
    activities: [],
    id: 'SUCCESSFACTORS_INTEGRATION',
    name: 'successfactors-integration',
    url: '/successfactors',
    target: '_self'
  }
];

export const EclientFooter = [
  {
    link: '',
    target: '_blank',
    title: 'Contact Us',
    env_val: 'CONTACT_US_LINK'
  },
  {
    link: '',
    target: '_blank',
    title: 'Privacy Policy',
    env_val: 'PRIVACY_POLICY_LINK'
  }
];
